import api from './api'
import { toastError } from './toast'
import { handleError } from './handle-error'

export const indexMachineHours = async params => {
  const result = new Promise((resolve, reject) => {
    api.get(`dashboard/machine-times`, { params: params })
      .then(result => {
        resolve(result.data)
      })
      .catch(error => {
        reject(null)
        toastError(handleError(error))
      });
  })
  return result
}